module.exports = __webpack_public_path__ + "static/media/Guitar1.18789c01.jpg";